<template>
  <div class="transition duration-100 bg-am-gray-100 hover:bg-coral-100 h-full flex flex-col justify-between">
    <div>
      <span class="p-2 flex items-center">
        <img v-lazy="creator.avatar" :alt="creator.name" class="rounded-full w-12 h-12 mr-2" />
        <div class="flex flex-col text-start">
          <span>{{ creator.name }}</span>
          <span class="text-gray-600 text-sm" :title="post.published_at">
            Published {{ post.published_at | fromNow }}
          </span>
          <span v-if="post.metrics_updated_at" class="text-gray-600 text-sm" :title="post.metrics_updated_at">
            Last updated {{ post.metrics_updated_at | fromNow }}
          </span>
        </div>
      </span>
      <a
        :href="post.url"
        target="_blank"
        class="thumbnail overflow-hidden flex items-center bg-cover bg-center"
        :style="style"
      ></a>
      <div v-if="post.caption" class="p-2">
        {{ post.caption | truncate(130) }}
      </div>
      <div v-if="post.campaign" class="text-right pr-2">
        Posted for
        <div class="font-montserrat">{{ post.campaign.title }}</div>
      </div>
    </div>
    <div>
      <div class="p-2">
        <dashboard-post-metric
          v-for="(metric, name) in post.metrics"
          :key="name"
          class="flex justify-between"
          :metric="metric"
        />
      </div>
    </div>
    <div class="text-center mb-1">
      <a :href="post.url" target="_blank" class="hover:text-primary-900" v-text="viewLabel"></a>
    </div>
  </div>
</template>

<script>
import { formatRelative, parseISO } from 'date-fns';
import DashboardPostMetric from './DashboardPostMetric.vue';

export default {
  name: 'DashboardPost',
  components: { DashboardPostMetric },
  filters: {
    fromNow(date) {
      return formatRelative(parseISO(date), new Date());
    },
    truncate(string, count) {
      if (!string || string === '') {
        return '';
      }

      return string.substring(0, count);
    },
  },
  props: {
    post: {
      type: Object,
    },
    creator: {
      type: Object,
    },
  },
  computed: {
    style() {
      return `height:200px; background-image: url(${this.post.thumb_url});`;
    },
    viewLabel() {
      if (this.post.media_product_type === 'FEED') {
        return 'View Post';
      }

      if (this.post.media_product_type === 'STORY') {
        return 'View Story';
      }

      if (this.post.media_product_type === 'REELS') {
        return 'View Reel';
      }

      return 'View';
    },
  },
};
</script>
